const benefitsslider = document.querySelectorAll('.benefit-slider-item');

for( i=0; i< benefitsslider.length; i++ ) {
  
  benefitsslider[i].classList.add('swiper-container-' + i);

  let adjustedindex = i + 1;
  $(`.benefit-slider-${adjustedindex}-contain .next-btn`).addClass(`next-${i}`);
  $(`.benefit-slider-${adjustedindex}-contain .prev-btn`).addClass(`prev-${i}`);


  var slider = new Swiper('.swiper-container-' + i, {
    slidesPerView: 3,
    spaceBetween: 8,
    loop: true,

    navigation: {
        nextEl: `.next-${i}`,
        prevEl: `.prev-${i}`,
      },


    breakpoints: {
      0: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
      1240: {
        slidesPerView: 3,
      }
    }
  });

}